<template>
  <div class="container">
    <div class="backgroundImage">
      <img src="../../../static/image/68wxLogo.png" class="68wxLogo" alt="">
    </div>
    <el-container class="bg">
      <div class="log-row">
        <img src="../../../static/image/reactBack.png" class="reactBack" alt="">
        <div class="card-page">
          <div class="main-title">注 册</div>
          <el-form :model="form" :rules="rules" status-icon ref="ruleForm" style="margin-top:20px" label-position="left" label-width="-10px">
            <el-form-item prop="name" class="card-item">
              <el-input type="text" v-model="form.name" auto-complete="off" placeholder="用户名" @keyup.enter.native="login"></el-input>
            </el-form-item>
            <el-form-item prop="companyName" class="card-item">
              <el-input type="text" v-model="form.companyName" auto-complete="off" placeholder="公司名称" @keyup.enter.native="login"></el-input>
            </el-form-item>
            <el-form-item prop="account" class="card-item card-item-username">
              <el-input type="text" v-model="form.account" auto-complete="off" placeholder="手机号" @keyup.enter.native="login"></el-input>
            </el-form-item>
            <el-form-item>
              <el-input type="text" v-model="form.code" auto-complete="off" placeholder="验证码" style="width:200px;"></el-input>
              <el-button v-if="codeBtnShow" type="primary" class="sendCodeBtn" style="width:116px;" @click="getCode">
                <!-- <span>发送验证码</span> -->
                <span>获取验证码</span>
              </el-button>
              <!-- <el-button v-if="!codeBtnShow" type="primary" class="sendCodeBtn" style="width:116px;"> -->
              <el-button v-else type="primary" class="sendCodeBtn" style="width:116px;">
                <span :key="count">{{count}} s</span>
              </el-button>
            </el-form-item>
            <el-form-item class="card-item">
              <div class="loginBtn" @click="login">
                <span>注册</span>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>

      <div class="footer-content">© {{format('yyyy',new Date(new Date()))}} - 弘智教育集团</div>
    </el-container>
  </div>
</template>

<script>
import Verify from "vue2-verify";
import md5 from "md5";
export default {
  components: {
    Verify,
  },
  data () {
    var validateMobile = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入手机号"));
      } else {
        if (value !== "") {
          var reg = /^1[3456789]\d{9}$/;
          if (!reg.test(value)) {
            callback(new Error("请输入正确的手机号码"));
          }
        }
        callback();
      }
    };
    return {
      verify: {
        type: 4,
        mode: "fixed",
        vOffset: 3,
        vSpace: 5,
        explain: "向右滑动完成验证",
        imgUrl: "static/image/",
        imgName: [
          "1.png",
          "2.png",
          "3.png",
          "4.png",
          "5.png",
          "6.png",
          "7.png",
          "8.png",
          "9.png",
          "10.png",
        ],
        imgSize: { width: "450px", height: "260px" },
        blockSize: { width: "40px", height: "40px" },
        barSize: { width: "450px", height: "40px" },
        showButton: false,
      },
      AgentInfoList: [],
      selectDataVisible: false,
      verifyVisible: false,
      validateCodePath: "",
      rules: {
        account: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        name: [{ required: true, message: "请输入用户民", trigger: "blur" }],
        companyName: [{ required: true, message: "请输入公司名称", trigger: "blur" }],
        // code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
      form: {
        account: "",
        name: '',
        companyName: '',
        code: "",
        password: "",
      },
      logData: {},
      buttonSize: document.body.clientWidth < 992 ? "mini" : "",
      findPasswordVisible: false,
      findPasswordForm: {
        mobile: "",
        code: "",
        password: "",
      },
      findPasswordRules: {
        mobile: [{ validator: validateMobile, trigger: "blur" }],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        password: [
          { required: true, message: "请输入新密码", trigger: "blur" },
        ],
      },
      codeBtnShow: true,
      count: "",
      timer: null,
    };
  },
  methods: {
    getGuid () {
      function S4 () {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
      }

      return (
        S4() +
        S4() +
        "-" +
        S4() +
        "-" +
        S4() +
        "-" +
        S4() +
        "-" +
        S4() +
        S4() +
        S4()
      );
    },
    changeCode () {
      this.rnd = this.getGuid();
      // this.validateCodePath =
      //   this.crmBaseUrl + "/system/validatecode/get?rnd=" + this.rnd;
    },
    login () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.AgentInfoList = [];
          var params = {
            name: this.form.companyName,
            mobile: this.form.account,
            userName: this.form.name,
            code: this.form.code
          }
          this.api.agentUserInfo.addAgentInfoListByAccount(params).then((result) => {
            if (result.success) {
              this.$message.success('操作成功');
              this.$router.push("/");
            } else {
              this.$message.error(result.message);
            }
          });
        } else {
          return false;
        }
      });
    },
    loginIn (id) {
      const loading = this.$loading.service({
        lock: true,
        text: "验证登录信息",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.api.system.login({
        account: this.form.account,
        password: md5(this.form.password),
        agentId: id,
      }).then((result) => {
        if (result.success) {
          this.logData = result.data;
          this.selectDataVisible = false;
          loading.close();
          this.verifyVisible = true;
        } else {
          this.selectDataVisible = false;
          loading.close();
          this.$message.error(result.message);
        }
      }).catch((error) => {
        loading.close();
        console.log(error);
      });
    },
    verifySuccess () {
      // this.$router.push({ name: "main" });
      this.$router.push(this.$route.query.redirect || "/main");
      this.$notify({
        title: "消息",
        message: "登录成功!",
        type: "success",
        duration: 1500,
      });
      this.$store.commit("signIn", this.logData);
    },
    findPassword () {
      this.findPasswordForm = {
        mobile: this.form.account,
        code: "",
        password: "",
      };
      this.findPasswordVisible = true;
    },
    getCode () {
      console.log('dsadsadasd')
      if (!this.form.name) {
        this.$message.warning('请先填写用户名')
        return false
      }
      if (!this.form.companyName) {
        this.$message.warning('请先填写公司名称')
        return false
      }
      if (!this.form.account) {
        this.$message.warning('请填写正确的手机号')
        return false
      }
      this.api.system.getSMSCode({ account: this.form.account }).then((result) => {
        console.log('dsadsadasd')
        if (result.success) {
          this.$message({
            message: "短信已发送",
            type: "success",
          });
          this.timeInterval();
        }
      }).catch((error) => {
        console.log(error);
      });
    },

    //倒计时
    timeInterval () {
      console.log('timeInterval')
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.codeBtnShow = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.codeBtnShow = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    confirmPassword () {
      this.$refs.findPasswordForm.validate((valid) => {
        if (valid) {
          this.api.system
            .resetPassword({
              mobile: this.findPasswordForm.mobile,
              smsCode: this.findPasswordForm.code,
              password: md5(this.findPasswordForm.password),
            })
            .then((result) => {
              if (result.success) {
                this.$message({
                  message: result.message,
                  type: "success",
                });
                this.findPasswordVisible = false;
              } else {
                this.$message.error(result.message);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
  },
  mounted () {
    this.changeCode();
    if (this.$store.state.isLogin) {
      this.$router.push(this.$route.query.redirect || "/main");
    }
  },
  computed: {
    isLogin () {
      return this.$store.state.isLogin;
    },
  },
};
</script>
<style scoped>
.container {
  width: 100%;
  height: 100%;
  min-width: 1200px;
  min-height: 600px;
}

.reactBack {
  width: 480px;
}
.log-row {
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 1000px;
  margin: 0 auto;
  align-items: center;
}
.card-page {
  width: 520px;
  height: 100%;
  padding: 40px 70px;
  /* padding: 30px 50px 40px 50px; */
  background: #fff;
  box-sizing: border-box;
  border: 1px solid #eaeaea;
}

.title {
  text-align: center;
  font-size: 20px;
}

.card-item {
  margin: 30px 0;
  height: 36px;
  width: 100%;
}

.card-item-password {
  margin-top: 90px;
}

.card-item-findLink {
  margin-top: -20px;
}

.loginBtn {
  width: 100%;
  color: #fff;
  border-radius: 56px;
  background-color: #136ffe;
  border: 0px;
  line-height: 56px;
  height: 56px;
  text-align: center;
  margin-top: 20px;
}
.loginBtn:hover {
  cursor: pointer;
  background-color: #136ffe;
}

.loginBtn span {
  font-size: 18px;
}

.codeImg {
  width: 80px;
  height: 40px;
  cursor: pointer;
}
/*
.main-title {
  background-color: #4d94ff;
  height: 60px;
  width: 240px;
  position: absolute;
  top: -30px;
  left: 100px;
  color: #fff;
  font-size: 20px;
  text-align: center;
  -webkit-border-radius: 30px;
  border-radius: 30px;
  line-height: 60px;
} */

.main-title {
  color: #000;
  font-size: 20px;
  text-align: center;
  margin-top: 20px;
}
.findLink {
  color: #4d97ff;
  font-size: 14px;
  text-align: center;
  cursor: pointer;
}

.main-logo {
  display: flex;
  display: -webkit-flex;
  position: absolute;
  left: calc(50% - 150px);
  top: 10%;
  height: 40px;
  line-height: 40px;
  z-index: 1111;
}

.main-logo div {
  font-size: 30px;
  width: 300px;
  color: #fff;
  align-items: center;
}
.bg {
  position: relative;
  margin-top: 60px;
}
.footer-content {
  position: absolute;
  bottom: -30px;
  width: 100%;
  font-size: 12px;
  color: #000;
  text-align: center;
}

.findPassword-item {
  margin: 10px 40px;
  height: 48px;
  width: 320px;
}

.sendCodeBtn {
  color: #fff;
  border-radius: 2px;
  background-color: #4d97ff;
  height: 36px;
  line-height: 1px;
}

.sendCodeBtn span {
  font-size: 16px;
}

.confirmPasswordBtn {
  color: #fff;
  border-radius: 2px;
  background-color: #4d97ff;
  height: 36px;
  width: 320px;
  line-height: 12px;
}

.confirmPasswordBtn span {
  font-size: 18px;
}

.textStyle {
  display: inline-grid;
  margin-left: 20px;
}
.lineStyle {
  border-left: 1px solid #ccc;
  margin-left: 20px;
}
.selectLogin {
  margin-bottom: 20px;
  border: 1px solid #eee;
  width: 400px;
  border-radius: 50px;
  height: 35px;
  line-height: 35px;
  text-align: center;
}
.selectLogin:hover {
  cursor: pointer;
  border: 1px solid #409eff;
}
.backgroundImage {
  display: flex;
  padding-top: 20px;
  padding-left: 60px;
}
.backgroundImage img {
  width: 100px;
}
</style>
<style>
.card-item .el-input__inner {
  border-radius: 2px;
  height: 36px;
}

.findPassword-item .el-input__inner {
  border-radius: 2px;
  height: 36px;
}
</style>



// WEBPACK FOOTER //
// src/components/register/index.vue